import { useState } from "react";
import { apiClient } from "../../apiclient/apiclient";
import PageContainer from "../../components/PageContainer";

const ChangePassword = () => {
  // hooks at top
  const [form, setForm] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  // block non-superAdmin
  if (!user || user.role !== "superAdmin") {
    return (
      <PageContainer>
        <div className="flex justify-center items-center min-h-[60vh]">
          <div className="bg-white rounded-xl shadow border border-red-200">
            <h2 className="text-lg font-semibold text-red-600">
              Access Denied
            </h2>
            <p className="text-sm text-slate-500 mt-1">
              Only Super Admin can change password.
            </p>
          </div>
        </div>
      </PageContainer>
    );
  }

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!form.current || !form.newPass || !form.confirm) {
      setError("All fields are required");
      return;
    }

    if (form.newPass !== form.confirm) {
      setError("New password and confirm password do not match");
      return;
    }

    try {
      setLoading(true);
      const res = await apiClient.post("/change-password", {
        current: form.current,
        newPass: form.newPass,
        confirm: form.confirm,
      });

      setSuccess(res.data.message || "Password updated successfully");
      setForm({ current: "", newPass: "", confirm: "" });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* MAIN HEADING - EDGE TO EDGE */}
      <div className="w-full border-b pt-3 ps-4 pb-4 border-slate-200 bg-blue-50">
        <h1 className="text-xl font-bold text-slate-800">Change Password</h1>
        <p className="text-sm text-slate-500 mt-1">
          Update your Super Admin password
        </p>
      </div>

      <div className="flex justify-center items-center">
        <div className="w-full max-w-md bg-white border p-6 mt-4">
          {/* ERROR */}
          {error && (
            <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </div>
          )}

          {/* SUCCESS */}
          {success && (
            <div className="mb-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded-md px-3 py-2">
              {success}
            </div>
          )}

          <div className="space-y-4">
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-slate-700">
                Current Password
              </label>
              <input
                type="password"
                placeholder="Enter current password"
                value={form.current}
                onChange={(e) => setForm({ ...form, current: e.target.value })}
                className="border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 rounded-lg px-3 py-2 text-sm bg-white outline-none transition w-full"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-slate-700">
                New Password
              </label>
              <input
                type="password"
                placeholder="Enter new password"
                value={form.newPass}
                onChange={(e) => setForm({ ...form, newPass: e.target.value })}
                className="border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 rounded-lg px-3 py-2 text-sm bg-white outline-none transition w-full"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-slate-700">
                Confirm New Password
              </label>
              <input
                type="password"
                placeholder="Confirm your new password"
                value={form.confirm}
                onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                className="border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 rounded-lg px-3 py-2 text-sm bg-white outline-none transition w-full"
              />
            </div>
          </div>

          <div className="flex justify-end mt-6">
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-orange-500 px-6 py-2 text-sm font-medium text-white hover:bg-orange-600 transition disabled:opacity-70 disabled:cursor-not-allowed w-full sm:w-auto"
            >
              {loading ? "Updating..." : "Update Password"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
